import Dialog from '@mui/material/Dialog'
import {CancelButton, StyledButton, StyledTypography} from './MarkerTooltipStyle'
import {Box, Divider, IconButton, Stack} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import {Close} from '@mui/icons-material'
import PropTypes from 'prop-types'
export default function ClearAllDialog({clearAll, open, handleCloseDialog, topPos}) {
  const theme = useTheme()
  return (
    <Dialog
      onClick={(e) => {
        e.stopPropagation()
        handleCloseDialog()
      }}
      open={open}
      onClose={handleCloseDialog}
      hideBackdrop
      PaperProps={{
        component: 'form',
        sx: {top: topPos, position: 'absolute', padding: `16px`, borderRadius: `4px`, width: '320px'}
      }}
    >
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <StyledTypography>Clear All Marker(s) </StyledTypography>
        <IconButton aria-label='close' onClick={handleCloseDialog}>
          <Close htmlColor={theme.palette.hpBase} />
        </IconButton>
      </Box>
      <Divider
        variant='fullWidth'
        sx={{
          marginBottom: (theme) => theme.spacing(1.5),
          marginTop: (theme) => theme.spacing(1),
          backgroundColor: theme.palette.hpBaseLighter
        }}
      />
      <Stack direction='column' spacing={2}>
        <StyledButton onClick={clearAll} actionType='remove'>
          Clear All
        </StyledButton>
        <CancelButton onClick={handleCloseDialog}>Cancel</CancelButton>
      </Stack>
    </Dialog>
  )
}

ClearAllDialog.propTypes = {
  clearAll: PropTypes.func,
  open: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
  topPos: PropTypes.number
}
